const trimTrailingSlash = (value: string | null | undefined): string => String(value || "").replace(/\/$/, "");

export const normalizeLoopbackHost = (rawUrl: string | null | undefined): string => {
  const normalized = trimTrailingSlash(rawUrl);
  if (!normalized) {
    return normalized;
  }

  try {
    const parsed = new URL(normalized);
    const browserHost = typeof window !== "undefined" ? window.location.hostname : "";
    const isLoopback = parsed.hostname === "127.0.0.1" || parsed.hostname === "localhost";
    const browserIsLoopback = browserHost === "127.0.0.1" || browserHost === "localhost";

    if (isLoopback && browserIsLoopback && parsed.hostname !== browserHost) {
      parsed.hostname = browserHost;
      return trimTrailingSlash(parsed.toString());
    }

    return normalized;
  } catch {
    return normalized;
  }
};

export const getApiBaseUrl = (): string =>
  normalizeLoopbackHost(trimTrailingSlash(process.env.REACT_APP_API_URL || ""));